import type { RequestFn } from '../http';

export type ContactSuggestionStatus = 'PENDING' | 'APPROVED' | 'REJECTED';
export type ContactSuggestionSource = 'CUSTOMER' | 'TECHNICIAN' | 'AUTO';
export type ContactSuggestionKind = 'NEW' | 'UPDATE';

export interface ContactSuggestion {
  id: string;
  customerId: string;
  name: string;
  email: string;
  phone: string | null;
  note: string | null;
  status: ContactSuggestionStatus;
  kind: ContactSuggestionKind;
  source: ContactSuggestionSource;
  reviewedAt: string | null;
  reviewNote: string | null;
  customerContactId: string | null;
  createdAt: string;
  updatedAt: string;
  customer: {
    id: string;
    name: string;
    cwCompanyId: number | null;
    weclappCustomerId: string | null;
  };
}

export function createContactSuggestionsApi(request: RequestFn) {
  return {
    getContactSuggestions(params?: {
      status?: ContactSuggestionStatus;
      customerId?: string;
      limit?: number;
      offset?: number;
    }): Promise<{ suggestions: ContactSuggestion[]; total: number }> {
      const qs = new URLSearchParams();
      if (params?.status) qs.set('status', params.status);
      if (params?.customerId) qs.set('customerId', params.customerId);
      if (params?.limit != null) qs.set('limit', String(params.limit));
      if (params?.offset != null) qs.set('offset', String(params.offset));
      const suffix = qs.toString() ? `?${qs.toString()}` : '';
      return request(`/hub/contact-suggestions${suffix}`);
    },

    // Techniker reicht einen Ansprechpartner-Vorschlag für einen gewählten Kunden ein.
    createContactSuggestion(body: {
      customerId: string;
      name: string;
      email: string;
      phone?: string;
      note?: string;
    }): Promise<{
      suggestion: {
        id: string;
        name: string;
        email: string;
        phone: string | null;
        note: string | null;
        status: ContactSuggestionStatus;
        createdAt: string;
      };
    }> {
      return request('/hub/contact-suggestions', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    approveContactSuggestion(
      id: string,
      body: { name: string; email: string; phone?: string; reviewNote?: string }
    ): Promise<{ ok: boolean; customerContactId: string }> {
      return request(`/hub/contact-suggestions/${encodeURIComponent(id)}/approve`, {
        method: 'PATCH',
        body: JSON.stringify(body),
      });
    },

    rejectContactSuggestion(
      id: string,
      body?: { reviewNote?: string }
    ): Promise<{ ok: boolean }> {
      return request(`/hub/contact-suggestions/${encodeURIComponent(id)}/reject`, {
        method: 'PATCH',
        body: JSON.stringify(body ?? {}),
      });
    },
  };
}
